import { api, ApiError } from "@/api/api";
import { ImageBase } from "@/api/images-types";
import { useQuery } from "@tanstack/react-query";

export function useEpisodeImagesByEpisodeId(episodeId: string | undefined) {
  return useQuery<{ images: ImageBase[] }, ApiError>({
    queryKey: ["GET", "episodeDetails", episodeId, "images"],
    queryFn: () => api.episodes.episodeId.images.get({ episodeId: episodeId! }),
    enabled: !!episodeId,
  });
}
